module.exports = __webpack_public_path__ + "img/map_z.c83182d5.png";